import React, { useState, useEffect } from 'react';
import {
  getAmazonSellerAccounts,
  getBankAccounts,
  getCompany,
  getPlaidLink,
} from '../components/API';
import LoadingBackdrop from '../components/LoadingBackdrop';
import AccountsStepper from '../components/Onboarding/accounts/AccountsStepper';
import { useCompanyContext } from '../contexts/Company';
import { useQuery } from '../hooks/useQuery';

export default function ConnectAccounts() {
  const [loading, setLoading] = useState(false);
  const [dataIsReady, setDataIsReady] = useState(false);
  const [amzAccounts, setAmzAccounts] = useState(null);
  const [hasBank, setHasBank] = useState(null);
  const [plaidLinkToken, setPlaidLinkToken] = useState(null);
  const [expandBank, setExpandBank] = useState(false);
  const { business, setBusiness } = useCompanyContext();
  const query = useQuery();

  async function getCompanyWrapper() {
    try {
      const business = await getCompany();
      setBusiness(business);
    } catch (error) {
      setBusiness({});
    }
  }

  async function getAmazonSellerAccountsWrapper() {
    try {
      const amzAccounts = await getAmazonSellerAccounts();
      setAmzAccounts(amzAccounts);
    } catch (error) {
      setAmzAccounts([]);
    }
  }

  async function getBankAccountsWrapper() {
    try {
      const bankAccounts = await getBankAccounts();
      bankAccounts.length > 0 ? setHasBank(true) : setHasBank(false);
    } catch (error) {
      console.error('Failed to get bank accounts', error);
      setHasBank(false);
    }
  }

  async function getPlaidLinkTokenWrapper() {
    try {
      const plaidToken = await getPlaidLink();
      setPlaidLinkToken(plaidToken.link_token);
    } catch (error) {
      console.error('Failed to get plaid link token', error);
      setPlaidLinkToken('error');
    }
  }

  async function getNeededDataFromServer() {
    setLoading(true);
    await Promise.all([
      getCompanyWrapper(),
      getAmazonSellerAccountsWrapper(),
      getBankAccountsWrapper(),
      getPlaidLinkTokenWrapper(),
    ]);
    setDataIsReady(true);
    setLoading(false);
  }

  useEffect(() => {
    getNeededDataFromServer();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isExpandBank = query.get('expand') === 'bank';
    setExpandBank(isExpandBank);
  }, [query, setExpandBank]);

  return (
    <React.Fragment>
      <LoadingBackdrop open={loading} />
      {dataIsReady && (
        <AccountsStepper
          amzAccounts={amzAccounts}
          business={business}
          hasBank={hasBank}
          setHasBank={setHasBank}
          plaidLinkToken={plaidLinkToken}
          expandBank={expandBank}
        />
      )}
    </React.Fragment>
  );
}
